import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    paddingTop: 65, // Aumentado o padding superior para o cabeçalho fixo não cobrir o texto
    paddingBottom: 40, // Aumentado o padding inferior pelo mesmo motivo do rodapé
    paddingHorizontal: 30,
    fontSize: 9,
    fontFamily: 'Helvetica',
    color: '#333333',
  },
  headerContainer: {
    position: 'absolute', // Define posição absoluta para fixar o elemento
    top: 20,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '2px solid #2c4778',
    paddingBottom: 8,
  },
  logoText: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#2c4778',
  },
  reportTitle: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'right',
  },
  subTitle: {
    fontSize: 10,
    color: '#666666',
    textAlign: 'right',
  },
  sectionTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    backgroundColor: '#cccc',
    color: '#000000',
    padding: 4,
    marginTop: 10,
    marginBottom: 6,
  },
  grid: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 2,
    border: '1px solid #e9ecef'
  },
  col6: { width: '50%', padding: 0, border: '0px solid #999999' },
  col3: { width: '25%', padding: 0, border: '0px solid #999999' },
  col4: { width: '33.33%', padding: 3 },
  col8: { width: '66.66%', padding: 3 },
  col12: { width: '100%', padding: 3 },
  label: {
    fontWeight: 'bold',
    color: '#555555',
    marginBottom: 1,
  },
  value: {
    padding: 4,
    backgroundColor: '#ffffff',
    border: '0px solid #e9ecef',
    borderRadius: 2,
    minHeight: 18,
  },
  photoContainer: {
    width: '50%',
    padding: 5,
    alignItems: 'center',
    marginBottom: 10,
  },
  photo: {
    width: '100%',
    height: 150,
    objectFit: 'contain',
    border: '1px solid #cccccc',
  },
  profile: {
    height: 32,
    objectFit: 'contain',
    border: '1px solid #cccccc',
  },
  photoCaption: {
    marginTop: 4,
    fontSize: 8,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 30,
    right: 30,
    textAlign: 'center',
    color: '#999999',
    fontSize: 8,
    borderTop: '1px solid #dee2e6',
    paddingTop: 5,
  }
});

export const TemplatePDF = ({ form, attachments }) => {
  const formatValue = (val) => {
    if (val === null || val === undefined || String(val).trim() === "") return "-";
    return String(val);
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>

        {/* CABEÇALHO PRINCIPAL - ADICIONADO ATRIBUTO "fixed" */}
        <View style={styles.headerContainer} fixed>
          <Image style={[styles.profile, { backgroundColor: 'transparent' }]} src={form.profile_image_path} />
          <View>
            <Text style={styles.reportTitle}>Atividade Técnica</Text>
          </View>
          <View>
            <Text style={styles.reportTitle}>{formatValue(form.os_code)}</Text>
            
          </View>
        </View>

        {/* SEÇÃO 1: DADOS DA OS / SOLICITAÇÃO */}
        <View wrap={true}>
          <Text style={styles.sectionTitle}>Responsabilidade técnica</Text>
          <View style={styles.grid}>
            <View style={styles.col6}>
              <Text style={styles.label}>Responsável:</Text>
              <Text style={styles.value}>{formatValue(form.responsavel_nome)}</Text>
            </View>
            <View style={styles.col3}>
              <Text style={styles.label}>Documento:</Text>
              <Text style={styles.value}>{formatValue(form.responsavel_documento)}</Text>
            </View>
            <View style={styles.col3}>
              <Text style={styles.label}>Contato:</Text>
              <Text style={styles.value}>{formatValue(form.responsavel_telefone)}</Text>
            </View>
          </View>
        </View>

        {/* SEÇÃO 2: DADOS DO SITE - Permitido wrap para não travar a primeira página */}
        <View wrap={true}>
          <Text style={styles.sectionTitle}>Dados da Atividade</Text>
          <View style={styles.grid}>
            <View style={styles.col12}>
              <Text style={styles.label}>Título da atividade:</Text>
              <Text style={styles.value}>{formatValue(form.locale_name)}</Text>
            </View>
            <View style={styles.col12}>
              <Text style={styles.label}>Localização:</Text>
              <Text style={styles.value}>{form.locale_street}, {form.locale_number}</Text>
            </View>
            <View style={styles.col12}>
              <Text style={styles.label}>Previsão:</Text>
              <Text style={styles.value}>Início: {form.start_date} | Previsão: {form.end_date || "Não definido"}</Text>
            </View>
            <View style={styles.col12}>
              <Text style={styles.label}>Descrição do Serviço / Observação:</Text>
              <Text style={[styles.value, { minHeight: 32 }]}>{form.os_description}</Text>
            </View>
          </View>
        </View>

        {/* SEÇÃO 5: REGISTRO FOTOGRÁFICO */}
        {attachments && attachments.length > 0 && (
          <View style={{ marginTop: 10 }} wrap={true}>
            <Text style={styles.sectionTitle}>Registro Fotográfico da Atividade</Text>
            <View style={styles.grid}>
              {attachments.map((img, index) => (
                <View style={styles.photoContainer} key={index} wrap={false}>
                  <Image style={[styles.photo, { backgroundColor: 'transparent' }]} src={img.arquivo} /> 
                  <Text style={styles.photoCaption}>
                    [{formatValue(img.status_nome)}] {formatValue(img.tipo)} {img.descricao ? `- ${img.descricao}` : ''}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        )}

        {/* RODAPÉ FIXO */}
        <Text style={styles.footer} render={({ pageNumber, totalPages }) => (
          `Relatório gerado por Gestec - Sistema de Gestão Técnica - Página ${pageNumber} de ${totalPages}`
        )} fixed />

      </Page>
    </Document>
  );
};